export default __webpack_public_path__ + "static/media/double_perso.b79d27fb.png";